import { useSelector } from 'react-redux'
import { RootState } from '~/store'
import { useConversationUuid } from './useConversationUuid'

interface UseMessagesProps {
  uuid?: string | null
}

export function useMessages({ uuid }: UseMessagesProps = {}) {
  const conversationUuid = useConversationUuid()
  const effectiveUuid = uuid ?? conversationUuid
  return useSelector((state: RootState) => state.chat.messages[effectiveUuid]) || []
}
